export var Granularity;
(function (Granularity) {
    Granularity["Day"] = "day";
    Granularity["Hour"] = "hour";
    Granularity["ThirtyMinutes"] = "30min";
    Granularity["FifteenMin"] = "15min";
    Granularity["FiveMin"] = "5min";
})(Granularity || (Granularity = {}));
